import { FC, useEffect, useRef, useState } from "react";
// import moment from "moment";
import { Badge, Col, Row, Tabs} from "antd";
import { InWorkWrapper, StyledTabs } from "./styled";
import { ContentWrapper } from "../styled";
import {
  ChatHistory,
  ChatInput,
  ScrollableWrapper,
  ShowMoreText,
  StyledTag,
} from "../..";
import { DrawerBodyElement } from "../../RightDrawer";
import { CommentDrawerDocumentsCollapse } from "../CommentDrawerDocumentsCollapse";
import { ResponsibleEngineerItem } from "../../CommentCard/ResponsibleEngineerItem";
import { ConditionalTooltipText } from "../../ConditionalTooltipText";
import { commentsTabs } from "../../../constants";
import { TCommentData, TCommentsTab } from "../../../types";
// import { markNotificationReaded, syncMessageHistory } from "services";
// import { useCentrifugeChats } from "hooks";

interface ICommentDrawerContentInfoProps {
  comment: TCommentData;
  messagesCount?: { partnersChat: number; internalChat?: number };
  status: TCommentsTab;
}

const commentsChatTabs = ["Чат с подрядчиками", "Внутренний чат"] as const;

type TCommentsChatTab = (typeof commentsChatTabs)[number];

const pickTagByCommentStatus = {
  [commentsTabs[0]]: {
    color: "#595959",
    tagColor: "#f5f5f5",
    title: "В работе",
  },
  [commentsTabs[1]]: {
    color: "#1677ff",
    tagColor: "#e6f4ff",
    title: "На согласовании",
  },
  [commentsTabs[2]]: {
    color: "#f5222d",
    tagColor: "#fff1f0",
    title: "Отклонено",
  },
  [commentsTabs[3]]: {
    color: "#52c41a",
    tagColor: "#f6ffed",
    title: "Отработано",
  },
};

export const CommentDrawerContentInfo: FC<ICommentDrawerContentInfoProps> = ({
  comment,
  messagesCount = { partnersChat: 0, internalChat: 0 },
  status,
}) => {
  const [currentTab, setCurrentTab] =
    useState<TCommentsChatTab>("Чат с подрядчиками");

  const isChatsSynced = useRef(false);

  // const [
  //   partnersMessages,
  //   isPartnersLoading,
  //   isPartnersChatConnected,
  //   internalMessages,
  //   isInternalLoading,
  //   isInternalChatConnected,
  // ] = useCentrifugeChats(comment.partnersChatId, comment.internalChatId);

  // useEffect(() => {
  //   if (
  //     !isChatsSynced.current &&
  //     isInternalChatConnected &&
  //     isPartnersChatConnected
  //   ) {
  //     if (comment.internalChatId) {
  //       syncMessageHistory(comment.internalChatId, moment());
  //     }

  //     if (comment.partnersChatId) {
  //       syncMessageHistory(comment.partnersChatId, moment());
  //     }

  //     isChatsSynced.current = true;
  //   }
  // }, [isInternalChatConnected, isPartnersChatConnected]);

  // useEffect(() => {
  //   if (
  //     !isPartnersLoading &&
  //     currentTab === commentsChatTabs[0] &&
  //     comment.partnersChatId
  //   ) {
  //     const lastMessageId = partnersMessages.at(-1)?.message_id;

  //     lastMessageId && markNotificationReaded({ chat: comment.partnersChatId });
  //   }

  //   if (
  //     !isInternalLoading &&
  //     currentTab === commentsChatTabs[1] &&
  //     comment.internalChatId
  //   ) {
  //     const lastMessageId = internalMessages.at(-1)?.message_id;

  //     lastMessageId && markNotificationReaded({ chat: comment.internalChatId });
  //   }
  // }, [currentTab, isInternalLoading, isPartnersLoading]);

  return (
    <>
      <InWorkWrapper>
        <ConditionalTooltipText
          className="comment-drawer-title"
          text={`Замечание ${
            comment.contractorShortName
              ? `от ${comment.contractorShortName}`
              : ""
          }`}
        />

        <div className="top-content-wrapper">
          <DrawerBodyElement
            description={
              <ConditionalTooltipText
                className="comment-title"
                text={comment.title}
              />
            }
            title="Название"
          />

          <DrawerBodyElement
            description={
              <ScrollableWrapper maxHeight={120}>
                <ShowMoreText rows={2} text={comment.description} />
              </ScrollableWrapper>
            }
            title="Замечание"
          />

          {comment.descriptionDecision && (
            <DrawerBodyElement
              description={
                <ScrollableWrapper maxHeight={312}>
                  <ShowMoreText rows={2} text={comment.descriptionDecision} />
                </ScrollableWrapper>
              }
              title="Решение"
            />
          )}

          {/* TODO Реализовать, когда будут ИЗМы!!! */}
          {false && status === commentsTabs[3] && (
            <DrawerBodyElement
              description={<CommentDrawerDocumentsCollapse comment={comment} />}
              title="Отработано"
            />
          )}
        </div>

        <div className="bottom-content-wrapper">
          <DrawerBodyElement
            description={
              <Row gutter={8} wrap={false}>
                <Col>
                  <StyledTag $textColor={"#1677ff"} color={"#e6f4ff"}>
                    {comment.number}
                  </StyledTag>
                </Col>

                <Col>
                  <Row gutter={8} wrap={false}>
                    <Col>
                      <ConditionalTooltipText
                        className="project-name"
                        text={comment.project.name}
                        withoutBreaks
                      />
                    </Col>

                    {!!comment.responsibleEngineers?.length &&
                      comment.responsibleEngineers.map((el) => (
                        <ResponsibleEngineerItem
                          fullName={el.fullName}
                          role={el.position}
                          key={el.id}
                        />
                      ))}
                  </Row>
                </Col>
              </Row>
            }
            title="№"
          />

          <DrawerBodyElement
            description={
              <ConditionalTooltipText text={comment.kitName} withoutBreaks />
            }
            title="Комплект"
          />

          <DrawerBodyElement
            description={
              <ConditionalTooltipText
                text={comment.documentation.name}
                withoutBreaks
              />
            }
            title="Том"
          />

          <DrawerBodyElement
            description={
              <StyledTag
                $textColor={pickTagByCommentStatus[status].color}
                color={pickTagByCommentStatus[status].tagColor}
              >
                {pickTagByCommentStatus[status].title}
              </StyledTag>
            }
            title="Статус"
          />

          <DrawerBodyElement
            description={<CommentDrawerDocumentsCollapse comment={comment} />}
            title="Документы"
          />
        </div>
      </InWorkWrapper>

      <StyledTabs
        activeKey={currentTab}
        moreIcon={null}
        onChange={(value) => setCurrentTab(value as TCommentsChatTab)}
        size="small"
      >
        {commentsChatTabs.map((tab) => (
          <Tabs.TabPane
            key={tab}
            tab={
              <>
                {tab}
                <Badge
                  count={
                    messagesCount[
                      tab === commentsChatTabs[0]
                        ? "partnersChat"
                        : "internalChat"
                    ]
                  }
                />
              </>
            }
          >
            <ContentWrapper className="chat-wrapper">
              <ChatInput
                chatId={
                  tab === commentsChatTabs[0]
                    ? comment.partnersChatId
                    : comment.internalChatId
                }
              />

              <ChatHistory
                isLoading={false
                  // tab === commentsChatTabs[0]
                  //   ? isPartnersLoading
                  //   : isInternalLoading
                }
                messages={[{created_at: "string",
                  message_id: 23,
                  text: "sdsdsd",
                  user_id: 33,
                  full_name: "ddsdd",
                  role: "sddds"},{created_at: "strindddg",
                  message_id: 233,
                  text: "sdsdsd",
                  user_id: 323,
                  full_name: "ddsddfdfd",
                  role: "sdsssdds"}]
                  // tab === commentsChatTabs[0]
                  //   ? partnersMessages
                  //   : internalMessages
                }
              />
            </ContentWrapper>
          </Tabs.TabPane>
        ))}
      </StyledTabs>
    </>
  );
};
